var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program-alarm",on:{"click":function($event){$event.preventDefault();return _vm.clickAlarm($event)}}},[(_vm.isOn)?_c('alarm-on'):_c('alarm-off')],1)}
var staticRenderFns = []

export { render, staticRenderFns }